export const GLOBAL_LABELS = 'global';
export const GLOBAL_ADD_TO_BAG_MODAL_LABELS = 'global.addedToBagModal';
export const CHECKOUT_BAGPAGE_LABELS = 'checkout.bagPage';
export const CHECKOUT_REVIEW_LABELS = 'checkout.review';

export const labelAfterPaySubmit = 'lbl_review_afterpaySubmit';
export const checkout = 'lbl_cta_checkout';
export const viewBag = 'lbl_cta_viewBag';
export const keepShopping = 'lbl_cta_keepShopping';
export const extendedPreOrderFooterMsg = 'lbl_extended_preOrder_footer_msg';
export const otherPayOptions = 'lbl_other_pay_options_added_to_bag';
export const couponsError = 'lbl_checkoutmodal_couponError';
export const labelAfterPayThresholdError = 'lbl_review_afterpayThresholdError';
export const backToBag = 'lbl_checkoutmodal_backToBag';
export const continueCheckout = 'lbl_checkoutmodal_continueCheckout';
export const warningMessage = 'lbl_sfs_cart_item_error';

const AddedToBagActionsLabels = {
  checkout: {
    bagPage: {
      [extendedPreOrderFooterMsg]:
        'Limited payment methods available in checkout due to select pre-order items.',
    },
    review: {
      [labelAfterPaySubmit]: 'Submit Order With Afterpay',
      [labelAfterPayThresholdError]:
        'Afterpay is available for orders that total between $[AfterPayMinOrderAmount] - $[AfterPayMaxOrderAmount]. Please select a new payment method.',
    },
    shipping: {
      [warningMessage]: 'Important message for your cart',
    },
  },
  global: {
    addedToBagModal: {
      [checkout]: 'Checkout',
      [viewBag]: 'View Bag',
      [keepShopping]: 'KEEP SHOPPING ',
      [otherPayOptions]: 'Other payment options',
    },
    checkoutConfirmation: {
      [couponsError]:
        'Some of the Coupons in your Basket has been expired, please remove to proceed further for checkout.',
      [backToBag]: 'BACK TO BAG',
      [continueCheckout]: 'CONTINUE TO CHECKOUT',
    },
  },
};

export default AddedToBagActionsLabels;
